import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOthersDropdownOpen, setIsOthersDropdownOpen] = useState(false);
  const [isSpeakersDropdownOpen, setIsSpeakersDropdownOpen] = useState(false);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Committee', path: '/committee' },
    { name: 'Abstract Submission', path: '/abstract-submission' },
    { name: 'Sponsorship', path: '/sponsorship' },
    { name: 'Important Dates', path: '/important-dates' },
    { name: 'Registration', path: '/registration' },
    { name: 'Contact', path: '/contact' },
  ];

  const speakerLinks = [
    { name: 'Plenary & Keynote Speaker', path: '/keynote-speaker' },
    { name: 'Invited Speaker', path: '/invited-speaker' },
    // { name: 'Oral Speaker', path: '/oral-speaker' },
    // { name: 'Technical Speaker', path: '/technical-speaker' },
  ];

  const othersLinks = [
    { name: 'Travel', path: '/travel' },
    { name: 'Tourism', path: '/tourism' },
    { name: 'Accommodation', path: '/accommodation' },
  ];

  return (
    <nav className="fixed top-0 left-0 w-full z-50  shadow-sm bg-[#1f2e6d] ">
      <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          {/* Logo Section */}
          <div className="flex-shrink-0 flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="/nclc-2026/assets/shardaLogo.webp" 
                alt="Sharda University" 
                className="h-12 w-auto"
                onError={(e) => { e.target.src = 'https://www.sharda.ac.in/attachments/university_logo/logo.png' }}
              />
            </Link>
          </div>

          {/* Desktop Links */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.slice(0, 2).map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="text-white hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors duration-200"
              >
                {link.name}
              </Link>
            ))}

            {/* Speakers Dropdown */}
            <div className="relative">
              <button
                onMouseEnter={() => setIsSpeakersDropdownOpen(true)}
                onMouseLeave={() => setIsSpeakersDropdownOpen(false)}
                className="flex items-center text-white hover:text-blue-200 px-3 py-2 text-sm font-medium transition-colors duration-200"
              >
                Speakers
                <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {isSpeakersDropdownOpen && (
                <div 
                  onMouseEnter={() => setIsSpeakersDropdownOpen(true)}
                  onMouseLeave={() => setIsSpeakersDropdownOpen(false)}
                  className="absolute left-0 mt-0 w-52 bg-white rounded-lg shadow-xl py-2 border border-gray-100 animate-in fade-in slide-in-from-top-2 duration-200"
                >
                  {speakerLinks.map((link) => (
                    <Link
                      key={link.name}
                      to={link.path}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                    >
                      {link.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {navLinks.slice(2).map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="text-white hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors duration-200"
              >
                {link.name}
              </Link>
            ))}

            {/* Others Dropdown */}
            <div className="relative">
              <button
                onMouseEnter={() => setIsOthersDropdownOpen(true)}
                onMouseLeave={() => setIsOthersDropdownOpen(false)}
                className="flex items-center text-white hover:text-blue-200 px-3 py-2 text-sm font-medium transition-colors duration-200"
              >
                Others
                <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {isOthersDropdownOpen && (
                <div 
                  onMouseEnter={() => setIsOthersDropdownOpen(true)}
                  onMouseLeave={() => setIsOthersDropdownOpen(false)}
                  className="absolute right-0 mt-0 w-48 bg-white rounded-lg shadow-xl py-2 border border-gray-100 animate-in fade-in slide-in-from-top-2 duration-200"
                >
                  {othersLinks.map((link) => (
                    <Link
                      key={link.name}
                      to={link.path}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                    >
                      {link.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 focus:outline-none transition-all"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-white border-b border-gray-100 animate-in slide-in-from-top duration-300">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navLinks.slice(0, 2).map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-all"
              >
                {link.name}
              </Link>
            ))}

            <div className="border-t border-gray-100 mt-2 pt-2">
              <span className="block px-3 py-2 text-sm font-semibold text-gray-400 uppercase tracking-wider">Speakers</span>
              {speakerLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-all pl-6"
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {navLinks.slice(2).map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-all"
              >
                {link.name}
              </Link>
            ))}

            <div className="border-t border-gray-100 mt-2 pt-2">
              <span className="block px-3 py-2 text-sm font-semibold text-gray-400 uppercase tracking-wider">Others</span>
              {othersLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-all pl-6"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;

